function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.808,
  y1: 0.5,
  x2: -1.573,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gold"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.075,
  stopColor: "#fece00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#fca704"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.803,
  stopColor: "#fa8e07"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fa8608"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.862,
  y1: 0.178,
  x2: -0.501,
  y2: 1.948,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e82b36"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b4005a"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -0.508,
  y1: -0.956,
  x2: 0.606,
  y2: 0.489,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2f8e5b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#4ea157"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.768,
  stopColor: "#67b054"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70b653"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3375",
  "data-name": "Group 3375",
  transform: "translate(-50 -450)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2762",
  "data-name": "Rectangle 2762",
  width: 275,
  height: 64,
  rx: 6,
  transform: "translate(50 450)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2449",
  "data-name": "Group 2449",
  transform: "translate(112.449 464.733)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_41262",
  "data-name": "Path 41262",
  d: "M82.613,24a5.6,5.6,0,1,0,5.62,5.6A5.52,5.52,0,0,0,82.613,24Zm0,8.995A3.241,3.241,0,0,1,79.451,29.6a3.169,3.169,0,1,1,6.322,0A3.24,3.24,0,0,1,82.613,33ZM70.349,24a5.6,5.6,0,1,0,5.622,5.6A5.52,5.52,0,0,0,70.349,24Zm0,8.995a3.24,3.24,0,0,1-3.16-3.394,3.169,3.169,0,1,1,6.322,0A3.241,3.241,0,0,1,70.349,33ZM55.763,25.724V28.1h5.684a4.945,4.945,0,0,1-1.294,2.991,5.819,5.819,0,0,1-4.39,1.739,6.321,6.321,0,0,1,0-12.642,6.053,6.053,0,0,1,4.285,1.7l1.675-1.677a8.287,8.287,0,0,0-5.96-2.4,8.7,8.7,0,1,0,0,17.4,7.946,7.946,0,0,0,6.066-2.44,7.848,7.848,0,0,0,2.059-5.557,7.828,7.828,0,0,0-.127-1.485Zm59.658,1.844A5.206,5.206,0,0,0,110.627,24a5.322,5.322,0,0,0-5.282,5.6,5.479,5.479,0,0,0,5.557,5.6,5.567,5.567,0,0,0,4.666-2.482l-1.908-1.272A3.2,3.2,0,0,1,110.9,33a2.847,2.847,0,0,1-2.715-1.7l7.488-3.1Zm-7.637,1.868a3.072,3.072,0,0,1,2.927-3.267,2.167,2.167,0,0,1,2.079,1.188Zm-6.087,5.43h2.46V18.4H101.7Zm-4.03-9.609H97.58A3.878,3.878,0,0,0,94.631,24a5.605,5.605,0,0,0,0,11.2,3.814,3.814,0,0,0,2.949-1.274h.085v.807c0,2.142-1.147,3.287-2.991,3.287a3.1,3.1,0,0,1-2.822-1.993l-2.142.89a5.337,5.337,0,0,0,4.964,3.309c2.886,0,5.324-1.7,5.324-5.833V24.344H97.665ZM94.843,33a3.213,3.213,0,0,1-3.118-3.373,3.239,3.239,0,0,1,3.118-3.416,3.157,3.157,0,0,1,2.991,3.416A3.13,3.13,0,0,1,94.843,33Zm32.1-14.6h-5.887V34.866h2.457V28.629h3.43a5.12,5.12,0,1,0,0-10.225Zm.064,7.934h-3.493V20.7h3.493a2.822,2.822,0,1,1,0,5.642Zm15.184-2.363A4.611,4.611,0,0,0,137.81,26.5l2.181.911a2.327,2.327,0,0,1,2.245-1.207,2.366,2.366,0,0,1,2.584,2.117v.169a5.432,5.432,0,0,0-2.563-.636c-2.352,0-4.743,1.292-4.743,3.707a3.8,3.8,0,0,0,4.087,3.62,3.462,3.462,0,0,0,3.133-1.61h.085v1.272h2.372V28.527C147.191,25.6,145.011,23.974,142.194,23.974ZM141.9,33c-.805,0-1.928-.4-1.928-1.4,0-1.27,1.4-1.757,2.606-1.757a4.372,4.372,0,0,1,2.245.551A2.979,2.979,0,0,1,141.9,33Zm13.934-8.662-2.817,7.137h-.084l-2.922-7.137h-2.648l4.384,9.974-2.5,5.549h2.563l6.755-15.522ZM133.7,34.866h2.457V18.4H133.7Z",
  transform: "translate(-6.444 -17.81)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2448",
  "data-name": "Group 2448"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M19.59,16.823a2.655,2.655,0,0,0-.615,1.864v29.33a2.651,2.651,0,0,0,.615,1.863l.1.1,16.43-16.43v-.388l-16.43-16.43Z",
  transform: "translate(-18.975 -16.297)",
  fill: "#40bff2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  d: "M36.075,35.5,30.6,30.019v-.388l5.477-5.477.124.071,6.489,3.687c1.852,1.053,1.852,2.776,0,3.828L36.2,35.427Z",
  transform: "translate(-13.456 -12.77)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M41.521,33.6,35.92,28,19.392,44.528a2.154,2.154,0,0,0,2.755.081L41.521,33.6",
  transform: "translate(-18.777 -10.944)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_111",
  "data-name": "Path 111",
  d: "M41.521,27.889,22.147,16.88a2.158,2.158,0,0,0-2.755.081L35.92,33.491Z",
  transform: "translate(-18.777 -16.435)",
  fill: "url(#linear-gradient-3)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Layer_3",
  "data-name": "Layer 3",
  transform: "translate(40.443 23.896)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M48.1,34.636c.88-.08,3.416-.325,5.885-.542,1.465-.121,2.727-.189,3.62-.229v1.085a11.1,11.1,0,0,0-2.631.218,4.7,4.7,0,0,0-3.065,4.243c0,2.618,2.44,3.446,4.625,3.527l-.393,1.138c-2.482-.107-5.316-1.436-5.316-4.434a5.427,5.427,0,0,1,2.5-4.529c-1.18.136-4.842.489-6.293.787L46.907,34.7C47.423,34.691,47.843,34.664,48.1,34.636Zm8.719,3.838-.691.326a12.517,12.517,0,0,0-1.111-1.911l.691-.3A16.129,16.129,0,0,1,56.821,38.473Zm1.547-.582-.7.326a12.074,12.074,0,0,0-1.153-1.885l.678-.313A20.743,20.743,0,0,1,58.367,37.891Z",
  transform: "translate(-46.907 -32.304)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M66.69,40.879H61.131v3.009c0,.72-.218,1.019-.72,1.18a10.48,10.48,0,0,1-2.794.177,5.057,5.057,0,0,0-.434-1c1.138.042,2.2.027,2.509.013.3,0,.42-.094.42-.38v-3H54.54V39.89h5.574v-2.2H55.449V36.73h4.665V34.641c-1.491.162-3.024.258-4.422.325a4.5,4.5,0,0,0-.258-.894,45.007,45.007,0,0,0,9.169-1.14l.758.8a25.551,25.551,0,0,1-4.23.8v2.2h4.8v.962h-4.8v2.2H66.69Z",
  transform: "translate(-41.764 -32.932)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M65.039,33.658c-.08.231-.2.666-.258.911a30.853,30.853,0,0,0-.651,5.138,14.249,14.249,0,0,0,.109,1.846c.231-.611.529-1.4.746-1.928l.582.435a29.378,29.378,0,0,0-.949,3.011,3.378,3.378,0,0,0-.067.6l.04.475-.976.067a16.817,16.817,0,0,1-.489-4.312,37.405,37.405,0,0,1,.6-5.384,7.787,7.787,0,0,0,.1-.949Zm3.066,6.511a4.975,4.975,0,0,0-.177,1.234c0,.611.407,1.208,2.251,1.208a14.582,14.582,0,0,0,3.322-.353l.013,1.138a17.724,17.724,0,0,1-3.349.271c-2.251,0-3.255-.745-3.255-2.007a7.768,7.768,0,0,1,.218-1.587Zm-.531-5.478a23.6,23.6,0,0,0,5.52,0V35.8a33.959,33.959,0,0,1-5.5,0Z",
  transform: "translate(-35.978 -32.506)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  d: "M77.273,33.41c0,2.4.311,7.513,5.627,10.674a4.789,4.789,0,0,0-.813.84A11.7,11.7,0,0,1,76.7,37.37c-1,3.512-2.711,5.98-5.411,7.567a6.557,6.557,0,0,0-.907-.8c3-1.56,4.665-4.286,5.492-8.083l.6.1c-.1-.624-.151-1.222-.177-1.736H72.96v-1Z",
  transform: "translate(-31.089 -32.61)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M90.721,42.93a3.438,3.438,0,0,1-2.469,1.126c-.882,0-1.491-.6-1.491-1.711,0-1.491.5-3.7.5-5a.956.956,0,0,0-1.071-1.1c-1.085,0-2.711,1.26-3.947,2.591-.025.569-.038,1.1-.038,1.572,0,1.222,0,2.035.052,3.24.015.231.042.571.07.813h-1.18c.013-.189.038-.582.038-.8.013-1.289.013-1.953.042-3.445,0-.136.013-.313.013-.516-.651.991-1.533,2.278-2.183,3.173l-.68-.936c.746-.936,2.293-3.024,2.971-4.082.027-.434.055-.869.08-1.289-.609.069-1.776.231-2.616.34l-.109-1.126a6,6,0,0,0,.88-.013c.434-.027,1.222-.107,1.913-.216.04-.639.067-1.113.067-1.262a5.034,5.034,0,0,0-.054-1l1.289.042c-.069.325-.177,1.085-.271,2.02l.067-.027.393.475c-.162.244-.393.609-.6.936-.028.244-.042.5-.067.758,1.043-.962,2.765-2.251,4.107-2.251a1.682,1.682,0,0,1,1.9,1.8c0,1.341-.5,3.662-.5,5.018,0,.46.218.813.693.813a2.95,2.95,0,0,0,2.02-1.113Z",
  transform: "translate(-25.703 -32.692)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M92.479,37.145c0,.88.067,2.183.136,3.349a10.67,10.67,0,0,1,4.176,2.291l-.651,1a9.358,9.358,0,0,0-3.485-2.209c.013.351.027.649.027.894,0,1.1-.678,2.047-2.469,2.047-1.843,0-3.214-.6-3.214-2.127,0-1.208,1.059-2.211,3.378-2.211a7.889,7.889,0,0,1,1.138.082c-.054-1.086-.107-2.32-.107-3.12,0-.773,0-1.885-.015-2.454a9.983,9.983,0,0,0-.107-1.331h1.3a11.461,11.461,0,0,0-.109,1.331c-.013.367,0,.84,0,1.369,1.071-.028,2.765-.1,3.973-.258l.04,1.029c-1.193.109-2.916.191-4.014.219Zm-.922,4.136a6.085,6.085,0,0,0-1.316-.136c-1.384,0-2.169.474-2.169,1.207s.745,1.153,2.034,1.153c.989,0,1.465-.462,1.465-1.383C91.57,41.905,91.557,41.619,91.557,41.281Z",
  transform: "translate(-19.895 -32.643)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M99.734,37.493a12.5,12.5,0,0,0-3.662.691c-.407.109-.8.269-1.125.392l-.34-1.247c.365-.04.827-.122,1.22-.2a17.867,17.867,0,0,1,4.015-.651c1.91,0,3.334,1.071,3.334,2.984,0,2.916-2.589,4.569-6.076,5.085l-.636-1.031c3.255-.407,5.56-1.682,5.56-4.1A2.025,2.025,0,0,0,99.734,37.493Zm2.372-3.5-.161,1.044c-1.495-.1-4.2-.367-5.724-.638l.176-1.031A35.913,35.913,0,0,0,102.105,33.993Z",
  transform: "translate(-14.769 -32.638)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}))))));

function SvgPlayStore(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 275,
    height: 64,
    viewBox: "0 0 275 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.bde19158.svg";
export { ForwardRef as ReactComponent };